import React from "react";

import ArticleCarousel from "../ArticleCarousel";

export default function RelatedPodcasts(props) {
    const {
        related_podcast_article = [],
        media_type = "",
        related_podcasts_view_all_button_label = null,
        related_podcasts_view_all_button_link = null,
        related_podcasts_autoplay = false,
        related_podcasts_autoplay_delay = 5000,
        related_podcasts_title = null,
    } = props;
    return (
        <>
            {
                (related_podcast_article || []).length > 0 && (
                    <ArticleCarousel
                        article={related_podcast_article}
                        wrap_articles={0}
                        media_type={media_type}
                        title={related_podcasts_title !== null && related_podcasts_title !== "" ? related_podcasts_title : "Related Podcasts"}
                        autoplay={related_podcasts_autoplay}
                        delay={related_podcasts_autoplay_delay}
                        view_all_button_label={related_podcasts_view_all_button_label}
                        view_all_button_link={related_podcasts_view_all_button_link}
                    />
                )
            }
        </>
    )
}